"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "Plataforma de treinamento online Liaogao e Academy",
    "captchaNotEmpty": "código de verificação deve ser preenchido",
    "accountNotEmpty": "A conta não pode estar vazia",
    "passwordBits": "O comprimento da senha não pode ser inferior a 6 dígitos",
    "incorrectTips": "Nome de usuário ou senha inserida incorretamente",
    "sign": "Conecte-se",
    "passwordNotEmpty": "a senha não pode ficar em branco",
    "passwordBitsLong": "O comprimento da senha não pode ser maior que 18 dígitos",
    "captchaTips": "código de verificação incorreto",
    "confirmNot": "A senha inserida é inconsistente com a senha confirmada",
    "inputAccount": "Insira o nome de usuário",
    "inputPassword": "Por favor insira a senha",
    "inputCaptcha": "por favor insira o código de verificação",
    "forgetPassword": "Esqueceu a senha",
    "nextStep": "Próxima Etapa",
    "inputUserName": "por favor insira o nome de usuário",
    "phoneNumber": "número de telefone",
    "phoneEmpty": "O número do telefone não pode estar vazio",
    "surePasswordEmpty": "confirmar a senha não pode ficar em branco",
    "userNameEmpty": "O nome de usuário não pode estar vazio",
    "getCaptcha": "obter código de verificação",
    "msgCaptcha": "Código de verificação SMS",
    "prevStep": "Anterior",
    "surePassword": "Por favor confirme sua senha",
    "reset": "Redefinir",
    "resetSuccess": "Reiniciar com sucesso",
    "resetSuccessTips": "Você redefiniu sua senha com sucesso, por favor, vá para o login",
    "loginNow": "Faça seu login agora mesmo",
    "copyRight": "Os direitos autorais são de propriedade de × shaft concepts thirty concepts problems concepts Copyright @ 2020 京 ICP 备案",
    "loginFail": "Login falhou, por favor tente novamente!",
    "captchaFail": "Verificação do código de verificação falhou",
    "failTips": "Falha na verificação",
    "inputOrigPassword": "Por favor insira a senha original",
    "inputNewPassowrd": "Por favor insira uma nova senha",
    "confimPassword": "Por favor confirme sua senha",
    "sure": "determinar",
    "cancel": "cancelar",
    "changePasswordSuccess": "a senha foi atualizada",
    "continueLogin": "registrar-se novamente",
    "resetLoginTips": "Você alterou sua senha com sucesso, você precisa fazer login novamente e sair automaticamente após 3 segundos",
    "passwordFormat": "O comprimento da senha é de 8 a 32 dígitos, incluindo números e letras maiúsculas e minúsculas",
    "changePassword": "mudar senha",
    "poor": "fraco",
    "middle": "dentro",
    "strong": "Forte",
    "logout": "Sair com sucesso",
    "formerPhone": "Número de telefone original",
    "newPhone": "Novo número de telefone",
    "changePhoneSuccess": "Número de celular modificado com sucesso",
    "changePhoneSuccessTips": "Você modificou com sucesso o seu número de telefone",
    "goHome": "Vá para a página inicial",
    "changePhone": "Modificar número de telefone celular",
    "newPhoneEmpty": "O novo número de telefone não pode estar vazio",
    "newPhoneFomat": "O novo formato do número de telefone está incorreto",
    "newPhoneSupport": "O novo número de telefone não pode ser igual ao número de telefone original",
    "newPhoneBinded": "Novo número de telefone vinculado",
    "orgPhoneEmpty": "O número de telefone original não pode estar vazio",
    "orgPhoneFormat": "O formato do número de telefone original está incorreto",
    "orgPhoneNot": "O número de telefone original está incorreto",
    "resetPassword": "redefinir senha",
    "phoneCaptchaEmpty": "O código de verificação do telefone não pode estar vazio",
    "accountVerif": "Verificação de conta",
    "phoneVerif": "Verificação de telefone",
    "resetDone": "Reinicialização completa",
    "phoneFormat": "O formato do número de telefone não está correto",
    "phoneBinded": "O número do celular foi vinculado",
    "loginVertif": "Autenticação de login",
    "clickGoHome": "Clique para retornar à página de login",
    "bingPhoneSuccess": "Vincular número de telefone celular com sucesso",
    "rightMessageChange": "Você pode editá-lo nas informações pessoais no lado direito da barra de navegação",
    "bingPhone": "Vincular número de telefone celular"
  },
  "index": {
    "setAsHomePage": "Configurar como primeira página",
    "addCollection": "Adicionar aos favoritos",
    "telephone": "linha direta de suporte",
    "Help": "Centro de ajuda",
    "SystemMessage": "Lembrete do sistema",
    "message": "notícia",
    "emptyMessage": "Vazio",
    "checkAllMessage": "ver tudo",
    "noMessage": "Sem dados",
    "fullScreen": "Exibição em tela inteira",
    "ExitSystem": "Saia deste sistema",
    "back": "Retorna",
    "top": "topo",
    "backToTop": "De volta ao topo",
    "homePage": "Casa",
    "course": "Aprendizagem do curso",
    "onlineCourse": "Aula Especial Online",
    "faceCourse": "Treinamento cara a cara",
    "examPractice": "Prática de exame",
    "dataDownLoad": "Baixar",
    "userInfo": "Centro pessoal",
    "Administration": "Histórico de gestão",
    "courseCategory": "tipos de curso",
    "examIsOver": "A avaliação está concluída",
    "onlineHours": "Horas online",
    "faceHours": "Horário de aula presencial",
    "notice": "anúncio",
    "checkAllNotice": "ver tudo",
    "backToTopButton": "De volta ao topo",
    "recommendCourse": "Cursos recomendados",
    "impotentCourse": "Curso chave",
    "newCourse": "Últimos cursos",
    "hotCourse": "Curso mais quente",
    "requiredCourses": "Curso obrigatório",
    "electiveCourses": "Disciplina facultativa",
    "startStudy": "comece a aprender",
    "continueStudy": "Continue estudando",
    "coursesRanking": "Classificação de Seleção de Curso",
    "studentRanking": "Classificação dos alunos",
    "currentUser": "Usuário atual",
    "userHead": "Foto do perfil",
    "currentHead": "Avatar atual",
    "change": "modificar",
    "accountPassword": "Senha da conta",
    "encryPhone": "Telefone secreto",
    "currentPhone": "Telefone atual",
    "userName": "nome do usuário",
    "head": "Avatar",
    "coverImage": "imagem de capa",
    "uploadError": "upload falhou",
    "autoSetHomeTips": "Seu navegador não suporta a configuração automática da página inicial, use o menu do navegador para configurá-la manualmente!",
    "operateConfig": "Esta operação foi rejeitada pelo navegador. Se você deseja habilitar esta função, digite about: config na barra de endereço e, em seguida, defina o valor de assinado.applets.codebase_principal_support como verdadeiro",
    "favoriteTips": "Devido à limitação da função do navegador 360, pressione Ctrl + D para marcar manualmente!",
    "autoFavorite": "Seu navegador não suporta isso, por favor, pressione Ctrl + D para marcar manualmente!",
    "required": "Este item é obrigatório",
    "to": "para",
    "trainingTime": "período de treinamento",
    "coursehours": "Horas de aula",
    "human": "pessoas",
    "wecome": "Bem-vinda!",
    "allCourses": "Todos os cursos"
  },
  "course": {
    "coursesCategory": "tipos de curso",
    "allCourses": "Todos os cursos",
    "electiveCourses": "Disciplinas eletivas",
    "requiredCourses": "Cursos requeridos",
    "collect": "Favoritos",
    "cancelCollect": "Desfavorito",
    "searchTips": "Por favor, insira o nome do curso",
    "startStudy": "comece a aprender",
    "continueStudy": "Continue estudando",
    "cancelConfirm": "Desfavorito",
    "cancelTips": "Confirme para cancelar o prompt",
    "confirmButton": "Botão Cancelar",
    "count": "Total",
    "item": "Artigo",
    "up": "Página anterior",
    "next": "Próxima página",
    "items": "Artigo / Página",
    "go": "Pule para",
    "page": "página",
    "man": "pessoas",
    "score": "Minuto",
    "courseYear": "ano",
    "courseTeachers": "professor",
    "noDesc": "Sem introdução",
    "teachersDesc": "Perfil do professor",
    "checkLog": "Ver registros",
    "reExam": "Reexaminar",
    "examLog": "Registro de exame",
    "viewPaper": "Ver papel de teste",
    "noPublicExam": "O papel de teste não será anunciado",
    "marking": "Marcando",
    "closeButton": "desligar",
    "examResultPage": "Página de resultados do exame",
    "examPage": "Página de exame",
    "startExam": "Comece o exame",
    "coursehours": "Horas de aula",
    "courseInfo": "Detalhes do curso",
    "courseChapter": "Capítulos do curso",
    "courseNote": "Notas de curso",
    "courseData": "Informação do curso",
    "courseExamination": "Exame",
    "evaluate": "Avaliação",
    "courseEvaluate": "Avaliação do curso",
    "no": "Primeiro",
    "chapter": "capítulo",
    "isEvaluate": "Avaliado",
    "uploadDate": "Tempo de upload",
    "className": "Nome da classe",
    "resourceSize": "Tamanho do recurso",
    "times": "Vezes",
    "typeViedo": "vídeo",
    "typeImage": "imagem",
    "typeDoc": "Documentação",
    "typeOuth": "de outros",
    "typeImages": "Múltiplas fotos",
    "newComment": "atualizado",
    "hotComment": "Mais quente",
    "openComment": "Eu quero comentar",
    "cancelButton": "cancelar",
    "publishButton": "lançamento",
    "commentTips": "Por favor, insira o conteúdo do comentário",
    "emptyCommentTips": "O conteúdo do comentário não pode estar vazio",
    "noteSource": "A partir de",
    "deleteNoteButton": "excluir",
    "needIETips": "O curso atual requer o navegador IE!",
    "donwNum": "tempos de download",
    "preview": "Antevisão",
    "relatedCourses": "Cursos relacionados",
    "studentsNum": "Número de cursos",
    "courseHours": "Horas de curso",
    "JoinLearning": "Junte-se à aprendizagem"
  },
  "onlineclass": {
    "allTheClass": "Todas as aulas",
    "beginClass": "Aulas começaram",
    "notBeginClass": "Sem aula",
    "endClass": "Fechadas",
    "searchThoseClass": "Pesquise a aula especial online em que você está interessado",
    "startLearn": "Entrar na classe",
    "registrationTime": "hora de registro",
    "to": "para",
    "trainingTime": "período de treinamento",
    "subjectsClass": "Cursos",
    "classStudy": "Estudo de classe",
    "quantityOfCourses": "Número de cursos",
    "numberOfParticipants": "Número de candidatos",
    "registerNow": "registrar agora",
    "resetRegister": "Retire o nome",
    "participating": "Ter participado",
    "subjects": "porta",
    "classExam": "Exame de classe",
    "notParticipat": "Não envolvido",
    "startExim": "Comece o exame",
    "handed": "realizar uma tarefa",
    "score": "Ponto",
    "cacheSave": "Armazenamento temporário",
    "subjectsNumber": "Número de portas",
    "notice": "Aviso prévio",
    "communication": "comunicação",
    "detail": "Detalhes",
    "courses": "curso",
    "allClass": "Tudo",
    "compulsory": "Obrigatório",
    "elective": "Eletiva",
    "Learned": "Aprendeu",
    "classPassIndicator": "Indicadores de aprovação nas aulas",
    "excellence": "excelente",
    "compulsoryNumber": "Número da passagem obrigatória",
    "electiveNumber": "Número de eletivas aprovadas",
    "compulsoryStandard": "Horas padrão obrigatórias",
    "electiveStandard": "Horário eletivo",
    "examIsPass": "Se o exame passou",
    "resource": "Recursos",
    "source": "dados",
    "new": "atualizado",
    "hot": "Mais quente",
    "updateTime": "Tempo de upload",
    "downloadCount": "Transferências",
    "download": "baixar",
    "resourceSize": "Tamanho do recurso",
    "resourceType": "Tipos de",
    "allType": "Todos os tipos",
    "videos": "vídeo",
    "images": "imagem",
    "document": "Documentação",
    "others": "de outros",
    "multiImages": "Múltiplas fotos",
    "inforCertificate": "certificado",
    "notSubmit": "não submetido",
    "submitHomework": "enviar lição de casa",
    "submitTime": "Hora de envio",
    "uploadHomework": "Carregar tarefa",
    "clickHere": "Clique aqui",
    "upload": "Envio",
    "formatSupport": "Suporte para formato de arquivo",
    "submited": "submetido",
    "notApproved": "Não revisado",
    "approved": "exame aprovado",
    "downloadHomework": "Baixar trabalho",
    "reSubmit": "Reenviar",
    "myScore": "Minha pontuação",
    "comments": "Comentários",
    "talk": "discutir",
    "category": "classificação",
    "classTalk": "Discussão em classe",
    "groupTalk": "discussão em grupo",
    "wantTalk": "Eu quero discutir",
    "publish": "lançamento",
    "undo": "cancelar",
    "delete": "excluir",
    "iknow": "deixa comigo",
    "faceCourseClass": "Treinamento cara a cara",
    "onlineClasses": "Aula Especial Online",
    "openReservation": "Aberto para inscrições",
    "talkTech": "conferencista",
    "address": "localização",
    "up": "em",
    "noon": "Meio dia",
    "down": "sob",
    "even": "atrasado",
    "classOvered": "A aula acabou",
    "nopassed": "Ainda não registrado",
    "inputTalkContent": "Por favor, insira o conteúdo da discussão",
    "groupMan": "Líder de grupo",
    "showAllGroup": "Ver todos os membros",
    "hideAllGroup": "Arrume todos os membros da equipe",
    "showAllMan": "Ver todos os alunos",
    "hideAllMan": "Arrumar todos os alunos",
    "reply": "Resposta",
    "isDelete": "Você tem certeza que quer deletar?",
    "cancelLike": "Ao contrário",
    "classNotStar": "O registro da classe ainda não começou",
    "classIsEnd": "O registro da aula terminou",
    "clickReset": "Clique no botão para retirar o nome",
    "agentRegister": "Inscreva-se novamente",
    "cancelRegister": "Cancelar registro",
    "reason": "o motivo",
    "inputReason": "Insira o motivo da revogação",
    "homework": "Operação",
    "leaveMaxBits": "O motivo do pedido de licença não pode exceder 100 palavras",
    "leaveNotEndTime": "O horário de início da licença não pode ser igual ao horário de término",
    "sizeNot": "O tamanho não pode exceder",
    "close": "desligar",
    "teacher": "professor",
    "noIntroduction": "Sem introdução"
  },
  "offlineclass": {
    "fullTimeToFace": "Instruções presenciais em tempo integral",
    "onlineToFace": "No trabalho",
    "allClass": "Todas as aulas",
    "openClass": "Aula aberta",
    "searchThoseClass": "Pesquise cursos de treinamento presenciais de seu interesse",
    "startLearn": "Entrar no aprendizado",
    "classHours": "Horas de aula",
    "h": "Tempo",
    "firstWeek": "Semana 1",
    "askLeave": "Eu quero me despedir",
    "monday": "Segunda-feira",
    "tuesday": "terça",
    "wednesday": "Quarta feira",
    "thursday": "Quinta feira",
    "fridays": "Sexta-feira",
    "saturdays": "no sábado",
    "sunday": "no domingo",
    "morning": "manhã",
    "afternoon": "a tarde",
    "evening": "à noite",
    "leaveType": "Tipo de licença",
    "selectLeaveType": "Selecione o tipo de licença",
    "leaveTime": "Intervalo",
    "selctLeaveTime": "Selecione o tempo de licença",
    "reasonLeave": "Razão para sair",
    "inputReasonLeave": "Por favor, insira o motivo para sair",
    "sure": "determinar",
    "selectTime": "período de seleção",
    "casualLeave": "Licença pessoal",
    "sickLeave": "Atestado médico",
    "seven": "dia",
    "one": 1,
    "two": "dois",
    "three": "três",
    "for": "quatro",
    "five": "Fives",
    "six": "seis",
    "clear": "Vazio",
    "evaluating": "Avaliação",
    "courseEvaluation": "Avaliação de ensino",
    "inputEvaluating": "Por favor, insira o conteúdo da avaliação",
    "beDoing": "Em progresso",
    "notStarted": "não começou",
    "evaluationInProgress": "Avaliação em andamento",
    "notEvaluation": "Não avaliado",
    "evaluationStartTime": "Hora de início da avaliação",
    "startEvaluation": "Iniciar avaliação",
    "classEvaluation": "Avaliação de classe",
    "photoCategory": "Classificação do álbum",
    "learningActivity": "Atividade de aprendizagem",
    "addPhoto": "Novas fotos adicionadas",
    "photoMessage": "Informação da foto",
    "photoName": "Nome da foto",
    "inputPhotoName": "Por favor insira um nome de foto",
    "uploadPhoto": "Upload de fotos",
    "formatSupport": "Suporte de formato de suporte",
    "tickets": "Zhang",
    "group": "grupo",
    "notGroup": "não classificado",
    "groupTalk": "Discussão em grupo",
    "teacherAbout": "Perfil do professor",
    "teacherTech": "Cursos realizados",
    "photos": "álbum de foto",
    "phontoRequier": "As fotos devem ser enviadas",
    "addPhoneTips": "Adicionado com sucesso, por favor aguarde a revisão",
    "sureDelete": "Tem certeza de que deseja excluir",
    "deleteSuccess": "excluído com sucesso",
    "phoneNameReq": "O campo do nome da foto é obrigatório",
    "longNotBits": "O comprimento não pode exceder 50 caracteres",
    "phoneIsOccur": "O nome da foto já existe",
    "evaluateTime": "Tempo de avaliação",
    "evalueteNotStar": "A avaliação não começou",
    "evaluateEnds": "A avaliação terminou",
    "isEvaluated": "Avaliado",
    "at": "dentro",
    "submit": "enviar",
    "seeEvalute": "Ver avaliação",
    "inputIdea": "Por favor, digite seus pensamentos",
    "submitFailure": "Falha ao entregar",
    "seeRecord": "Ver registros",
    "examRecord": "Registro de exame",
    "seeSubmite": "Ver papel de teste",
    "resultPage": "Página de resultados do exame",
    "hoursStandard": "Não posso fazer o exame se as horas de aula não corresponderem ao padrão",
    "examPage": "Página de exame",
    "questionnaire": "Questionário",
    " coursesTaught": "Cursos ministrados",
    "passed": "por",
    "is": "sim",
    "not": "não",
    "passedState": "Status de aprovação",
    "sketch": "esboço, projeto",
    "partySchool": "Aula de treinamento da escola de festas",
    "searchPartySchool": "Pesquise a aula de treinamento para festas de que você está interessado"
  },
  "exam": {
    "answerWarning": "A pergunta deste exame é uma pergunta única irreversível, por favor, tome cuidado antes da próxima pergunta",
    "inputAnswerTips": "por favor, coloque sua resposta",
    "problemPoints": "Analise de problemas",
    "examination": "Inscreva-se para um exame",
    "knowledgeCompetition": "Concurso de conhecimento",
    "practice": "Prática autônoma",
    "notRegister": "Não registrado",
    "reviewAudit": "sob revisão",
    "auditNoPass": "Auditoria falhou",
    "participanted": "registrado",
    "participant": "inscrever-se",
    "examTime": "hora do exame",
    "examHours": "duração",
    "registration": "Cadastre-se com sucesso",
    "reRegistration": "Retire o nome",
    "wrongQuestion": "Banco de perguntas errado",
    "noInvolvement": "Não envolvido",
    "involvement": "Participou",
    "searchExamPractice": "Pesquise exames e exercícios do seu interesse",
    "practiced": "Praticado",
    "startPractice": "Comece a praticar",
    "toFavorite": "Adicionar aos favoritos",
    "prevPrevious": "Pergunta anterior",
    "nextPrevious": "próxima questão",
    "submitAnswers": "Enviar resposta",
    "rightAnswers": "resposta correta",
    "yourAnswers": "sua resposta",
    "questionsAnalysis": "Análise de questões",
    "noAnalysis": "Sem resolução",
    "accuracy": "Taxa correta",
    "continuePracticed": "Continue praticando",
    "topics": "tema"
  },
  "source": {
    "allResource": "Todos os recursos",
    "commonResource": "Recursos gerais",
    "classResource": "Recursos de classe",
    "resourceCategory": "Classificação de recursos",
    "searchResource": "Pesquise os recursos nos quais está interessado",
    "resourceTalk": "Avaliação de recursos",
    "previewResource": "Antevisão do recurso",
    "helpPoint": "Manual de ajuda",
    "isEvaluation": "Você já avaliou!",
    "selectEvaluation": "Você não selecionou uma classificação!",
    "evaluationSuccess": "Avaliação bem sucedida",
    "topRelise": "Topo",
    "className": "Nome da classe",
    "resourceEvaluation": "Avaliação de recursos"
  },
  "usercenter": {
    "386": "Arquivo de aprendizagem",
    "myCourse": "Meus cursos",
    "hours": "Tempo",
    "loginAccount": "Conta de login",
    "htllo": "Olá",
    "welcomeMessage": "Desejo-lhe feliz todos os dias",
    "underway": "Você está fazendo",
    "annualAssessment": "Avaliação anual",
    "searchTips": "Digite o nome do curso pesquisado",
    "completed": "Acabado",
    "allCourses": "Todos os cursos",
    "requiredCourses": "Cursos requeridos",
    "electiveCourses": "Disciplinas eletivas",
    "all": "Tudo",
    "ongoing": "em processamento",
    "learnTo": "Aprender a",
    "inExams": "Faça o teste",
    "noExams": "Sem exame",
    "delete": "excluir",
    "pleaseSelect": "por favor escolha",
    "searchOnlineTips": "Pesquise por aulas especiais online de seu interesse",
    "passedCourse": "passado",
    "failedCourse": "Não passou",
    "myOnlineCourse": "Minha aula especial online",
    "myFaceCourse": "Minha aula de treinamento face a face",
    "searchFaceTips": "Pesquise os cursos nos quais está interessado",
    "myExams": "Meu exame",
    "allExams": "Todos os exames",
    "makeUpExam": "Para ser maquiado",
    "marking": "Marcando",
    "onExam": "Exame em progresso",
    "passedExam": "Aprovado no exame",
    "examHours": "Duração do teste",
    "examOver": "O exame acabou",
    "exam": "exame",
    "examLog": "Registro de exame",
    "myScore": "Minha pontuação",
    "surplusMakeUpExam": "Exame de maquiagem restante",
    "times": "Vezes",
    "searchExamTips": "Insira o nome da pesquisa",
    "haveTime": "Tempo restante",
    "question": "questão",
    "eachQuestion": "Cada questão",
    "score": "Minuto",
    "examExplain": "Descrição do exame",
    "confirmHandExams": "Se deve confirmar o envio",
    "autoSaveFailed": "Falha ao salvar automaticamente",
    "autoSaveSuccess": "Salvamento automático",
    "handExamsSuccess": "Entregue com sucesso",
    "yourScore": "Sua pontuação",
    "noPublicAnswers": "As respostas não serão anunciadas para este exame",
    "noPublicResult": "O papel de teste não será anunciado",
    "reExam": "Reteste",
    "practice": "Exercício",
    "hasCollected": "coletado",
    "emptyAnswer": "O conteúdo da opção ou da resposta não pode estar vazio",
    "isCorrect": "Solução positiva",
    "myCollected": "minha coleção",
    "courseCollected": "Coleção de cursos",
    "examCollected": "Perguntas de teste",
    "deleteCollected": "Remover favorito",
    "myLeave": "Minha licença",
    "allLeave": "Todos saem",
    "needAudit": "Pendente",
    "auditDate": "tempo de aplicação",
    "searchLeaveTips": "Pesquise por licença em que está interessado",
    "checkInfo": "Veja detalhes",
    "cancelLeave": "Revogar licença",
    "leaveInfo": "Deixe os detalhes",
    "leaveState": "Estado atual",
    "teamLeader": "Líder de grupo",
    "committeeMembers": "Comitê de Inspeção Disciplinar da Organização",
    "headmaster": "diretor",
    "schoolLeader": "Líder escolar",
    "student": "Estagiário",
    "auditMessage": "Razão de aprovação",
    "onBusiness": "Para negócios",
    "personal": "Para ganho pessoal",
    "rejectReasons": "Razão para rejeição",
    "confirmCancel": "Confirme se deseja revogar a licença",
    "cancelButton": "Revogar",
    "cancelTitle": "Confirmação de revogação",
    "empty": "não",
    "wrongQuestionBank": "Meu banco de perguntas errado",
    "searchWrongTips": "Procure a pergunta errada na qual você está interessado",
    "deleteWrongQuestion": "Remova o banco de perguntas errado",
    "myQuestionnaire": "Meu questionário",
    "isCompleted": "completado",
    "isOver": "sobre",
    "searchQuestionnaireTips": "Digite o nome do questionário de pesquisa",
    "questionnaireDate": "Tempo do questionário",
    "startQuestionnaire": "Comece a responder",
    "checkQuestionnaire": "Ver questionário",
    "allTeacher": "Todos os professores",
    "newTeacher": "Adicionar professor",
    "searchTeacherTips": "Procure professores nos quais você está interessado",
    "checkTeacher": "Visão",
    "editTeacher": "editar",
    "workingIn": "Trabalhei em",
    "location": "Localização permanente",
    "confirmDelete": "Confirmação de exclusão",
    "confirmDeleteTips": "Confirmar exclusão",
    "recommendTeacher": "Recomendação do professor",
    "addTeachers": "Novos professores",
    "teacherInfo": "Informação pessoal",
    "teacherName": "Nome do professor",
    "workUnit": "Empregador",
    "contact": "Detalhes do contato",
    "teacherNameTips": "Por favor, digite o nome do professor",
    "teacherWorkUnitTips": "Insira o empregador",
    "teacherContactTips": "Insira as informações de contato do professor",
    "teacherLocationTips": "Insira o local permanente",
    "teacherDescTips": "Por favor, insira o perfil do professor",
    "teachingInfo": "Informação de ensino",
    "teachingExpertise": "Experiência de ensino",
    "fitLevel": "Adequado para o ensino de nível de objeto",
    "fitBusiness": "Adequado para linhas de negócios",
    "ruleNumber": "Insira um número inteiro com 8 dígitos (incluindo 8)",
    "rulePhone": "Por favor insira um número de telefone válido",
    "ruleString": "Digite 80 caracteres (incluindo 80)",
    "ruleIsNumber": "Por favor insira o número",
    "pause": "Armazenamento temporário",
    "teachingStyle": "Estilo de palestra",
    "teachingExpertiseTips": "Insira a experiência de ensino do professor",
    "fitLevelTips": "Selecione o nível que se adequa ao público-alvo",
    "fitBusinessTips": "Escolha uma linha de negócios adequada",
    "chargeInfoTips": "Insira o padrão de cobrança",
    "teachingStyleTips": "Por favor, insira o estilo de palestra do professor",
    "otherInfo": "Outra informação",
    "recommendUnit": "Recomendado por",
    "otherOption": "Outros assuntos",
    "otherOptionTips": "Insira outras coisas que precisam ser adicionadas",
    "isRequired": "Este item é obrigatório",
    "pauseSuccess": "Salvo com sucesso",
    "phoneWrong": "Por favor insira um número de telefone válido",
    "junior": "Estudante do ensino médio",
    "highSchool": "Estudante do ensino médio",
    "english": "Inglês",
    "mathematics": "matemática",
    "recommendSuccessTips": "Você enviou o professor recomendado com sucesso. Depois que a revisão for aprovada, o professor será adicionado ao grupo de professores",
    "goBackrecommend": "Voltar para recomendação do professor",
    "checkTeacherInfo": "Ver professores",
    "currentState": "Estado atual",
    "chargeInfo": "Cobranças",
    "myCertificate": "Meu certificado",
    "learningArchives": "Arquivo de aprendizagem",
    "allCertificate": "Todos os certificados",
    "onlineCourse": "Aula online",
    "faceCourse": "Aula cara a cara",
    "exams": "exame",
    "baseInfo": "informação básica",
    "userName": "nome do usuário",
    "name": "Nome",
    "company": "Unidade atual",
    "learningExperience": "História de estudo",
    "assessmentIndex": "Índice de avaliação",
    "assessmentStatus": "Status de avaliação",
    "assessmentTime": "hora do teste",
    "onlineLearning": "Aprendizagem online",
    "year": "ano",
    "faceOutProduceHours": "Aulas presenciais (horas de aula)",
    "notFaceOutProduceHours": "Instrução presencial não profissional (horas de aula)",
    "onlineCenterLearnHours": "Aprendizagem intensiva online (horas de aula)",
    "onlineSelfLearnHours": "Autoaprendizagem online (horas de aula)",
    "outCompanyLearnHours": "Estude no exterior (horas de aula)",
    "allHours": "período total",
    "onlineSelfLearn": "Aprendizagem online autônoma",
    "onlineCentralizedLearning": "Aprendizagem intensiva online",
    "outCompanyLearn": "Estudo de unidade estrangeira",
    "faceTrain": "Treinamento cara a cara",
    "myNotice": "Minha mensagem",
    "noticeSearchTips": "Pesquise notícias de seu interesse",
    "systemNotice": "Lembrete do sistema",
    "message": "Carta particular"
  },
  "questionnaire": {
    "notParticipat": "Não envolvido",
    "description": "Descrição do questionário",
    "save": "Salve ",
    "export": "Exportar",
    "printing": "impressão",
    "handed": "realizar uma tarefa",
    "topics": "tema",
    "examList": "Lista de perguntas de teste",
    "tableQuestions": "Questão da mesa",
    "newLine": "Adicionar linha",
    "deleteLine": "Apagar linha",
    "sort": "Número de série",
    "content": "conteúdo",
    "shortQuestion": "Resposta curta",
    "inputContent": "Por favor, insira o conteúdo da resposta",
    "multiple": "Múltipla escolha",
    "single": "Múltipla escolha",
    "saveSuccess": "Salvo com sucesso",
    "submitSuccess": "submetido com sucesso",
    "submitTips": "Você enviou o questionário com sucesso, obrigado por sua participação",
    "closePage": "Fechar esta página"
  },
  "play": {
    "endStudy": "Fim do estudo",
    "tips": "Dicas",
    "playTips": "Lembrete: para garantir que seu tempo de estudo seja registrado normalmente pelo sistema, clique no botão \"Finalizar Estudo\" no canto superior direito para sair do estudo. Se você fechar o navegador diretamente, seu tempo de estudo pode não ser registrado normalmente.",
    "notShowAgain": "Não mostre esta mensagem novamente",
    "gotIt": "deixa comigo",
    "chapter": "capítulo",
    "chapterText1": "Primeiro",
    "chapterText2": "capítulo",
    "note": "notas",
    "noteBlockTitle": "notas",
    "evaluate": "Avaliação",
    "evaluateStar": "Estrela",
    "saveEvaluate": "enviar",
    "notePlaceholder": "Por favor insira notas",
    "closeTips": "O sistema pode não salvar suas alterações",
    "closeButton": "vá embora",
    "autoStop": "Pare de jogar automaticamente",
    "autoStopTips": "Como você não opera há muito tempo, o sistema interrompe automaticamente a reprodução do vídeo",
    "confirmOut": "Tem certeza que deseja parar de jogar?",
    "closeOrNot": "Se deve fechar a janela atual",
    "noCoursePlay": "Não há material didático jogável no curso atual",
    "attention": "Observe!"
  }
};